import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
} from "@mui/material";

const tasks = [
  {
    id: 1,
    status: "Completed",
    title: "Buy Groceries",
    date: "12 July, 2025",
    time: "5:30 PM",
    priority: "High Priority",
    category: "Work",
    location: "Apptunix Sector 77, Mohali",
    sharedWith: ["Alex Morgan", "Divya Kapoor"],
    repeat: "Daily",
    reminder: "10 min before",
  },
  {
    id: 2,
    status: "Pending",
    title: "Prepare Presentation",
    date: "24 July, 2025",
    time: "10:00 AM",
    priority: "High Priority",
    category: "Work",
    location: "Office",
    sharedWith: ["John Doe"],
    repeat: "One-Time",
    reminder: "30 min before",
  },
  {
    id: 3,
    status: "Pending",
    title: "Doctor Appointment",
    date: "25 July, 2025",
    time: "03:30 PM",
    priority: "Low Priority",
    category: "Health",
    location: "Apollo Clinic",
    sharedWith: [],
    repeat: "One-Time",
    reminder: "1 hour before",
  },
];

const LoginHistory = () => {
  const historyData = [
    {
      id: 1,

      loginTime: "2025-03-01 09:15 AM",
      ipAddress: "192.168.1.15",
      device: "Chrome - Windows 10",
      status: "Success",
    },
    {
      id: 2,
  
      loginTime: "2025-02-28 08:40 PM",
      ipAddress: "192.168.1.22",
      device: "Safari - iPhone 14",
      status: "Failed",
    },
    {
      id: 3,

      loginTime: "2025-02-28 07:10 PM",
      ipAddress: "192.168.1.45",
      device: "Edge - Windows 11",
      status: "Success",
    },
  ];
  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr. No.</TableCell>

              <TableCell>Login Time</TableCell>
              <TableCell>IP Address</TableCell>
              <TableCell>Device</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {historyData.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
               
                <TableCell>{row.loginTime}</TableCell>
                <TableCell>{row.ipAddress}</TableCell>
                <TableCell>{row.device}</TableCell>
                <TableCell>{row.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default LoginHistory;
